import { render } from "./auth.vue?vue&type=template&id=3bc95634"
const script = {}

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__